var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('f7-navbar',[_c('f7-nav-left',{attrs:{"back-link":"返回"}}),_c('f7-nav-title',[_vm._v(_vm._s(_vm.navName))]),_c('f7-nav-right',[_c('f7-link',{attrs:{"icon":"icon-bars","panel-open":"right"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }